import React, { useState, useEffect } from 'react';
import Loader from 'react-loader-spinner';
import RatingInputStar from '../RatingInputStar/RatingInputStar';
import './VotePageMobileView.css';
import { Form } from 'react-bootstrap';

export const VotePageMobileView = (props) => {
    const {
        loading,
        ownPage,
        teams,
        onNoteChange,
        onSave,
        onRateChange,
        categories
    } = props;

    const [selectedTeam, setSelectedTeam] = useState(null);

    useEffect(() => {
        if (!loading && teams.length > 0 && selectedTeam) {
            const updatedSelectedTeam = teams.find(t => t.id === selectedTeam.id);
            if (updatedSelectedTeam) {
                setSelectedTeam(updatedSelectedTeam);
            } else {
                setSelectedTeam(null);
            }
        } else if (!loading && teams.length === 0) {
            setSelectedTeam(null);
        }
    }, [loading, teams]);

    const handleTeamSelect = (e) => {
        const teamId = parseInt(e.target.value);
        const team = teams.find(t => t.id === teamId);
        setSelectedTeam(team);
    };

    const handleCloseTeamDetails = () => {
        setSelectedTeam(null);
    };

    const handleRateChangeLocal = (categoryId, newScore) => {
        if (selectedTeam && onRateChange) {
            onRateChange(selectedTeam.id, categoryId, newScore);
        }
    };

    const handleNoteChange = (e) => {
        const newNotes = e.target.value;
        if (selectedTeam && onNoteChange) {
            onNoteChange(selectedTeam.id, newNotes);
        }
    };

    const handleSave = async () => { 
        await onSave(); 
        handleCloseTeamDetails();
    };

    if (loading) {
        return (
            <div className="spinner-container">
                <Loader type="TailSpin" color="#CF240A" height="60" width="60" />
            </div>
        );
    }

    return (
        <div className="mobile-section-container">
            {!selectedTeam ? (
                <div className="team-select-container">
                    <select
                        className="team-dropdown"
                        onChange={handleTeamSelect}
                        value=""
                    >
                        <option className="team-option" value="" disabled>Select a team</option>
                        {teams.map(team => (
                            <option className="team-option" key={team.id} value={team.id}>{team.name}</option>
                        ))}
                    </select>
                </div>
            ) : (
                <div className="team-details-container">
                    <div className="team-details-header">
                        Team: {selectedTeam.name}
                        <button type="button" className="close-btn close-details-btn" onClick={handleCloseTeamDetails} aria-label="Close">
                            <i className="fas fa-times"></i>
                        </button>
                    </div>

                    <div className="team-scores-mobile">
                        {categories.map(category => {
                            const score = selectedTeam.scores.find(s => s.categoryId === category.id);
                            const currentScoreValue = score ? score.score : 0;
                            return (
                                <div key={category.id} className="category-item-mobile">
                                    <label className="category-name-mobile">{category.name}</label>
                                    <div className="score-slider-wrapper">
                                        <input
                                            type="range"
                                            min="0"
                                            max="5"
                                            step="0.5"
                                            value={currentScoreValue}
                                            onChange={(e) => handleRateChangeLocal(category.id, parseFloat(e.target.value))}
                                            disabled={!ownPage}
                                            className="rating-slider"
                                        />
                                        <RatingInputStar
                                            value={currentScoreValue}
                                            edit={false}
                                            maxRating={5.0}
                                            step={0.5}
                                        />
                                    </div>
                                </div>
                             );
                        })}
                    </div>

                    <div className="notes-section-mobile">
                        <label>Enter Notes:</label>
                        <Form.Group controlId="notesTextArea">
                            <Form.Control
                                as="textarea"
                                rows={12}
                                value={selectedTeam.notes || ''}
                                onChange={handleNoteChange}
                                readOnly={!ownPage}
                                className="notes-textarea"
                            />
                        </Form.Group>
                    </div>

                    <div className="mobile-actions">
                        <button className="btn btn-primary" onClick={handleSave} disabled={!ownPage}>
                            Save
                        </button>
                        <button className="btn btn-link ms-16" onClick={handleCloseTeamDetails}>
                            Cancel
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default VotePageMobileView;